import { ItemDiscountMeasureOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ItemDiscountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/item-discount";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo } from "react";

const MEASURE_OPTIONS: RadioGroupOption<ItemDiscountMeasureOption>[] = [
  { id: ItemDiscountMeasureOption.PERCENT, label: "%" },
  { id: ItemDiscountMeasureOption.AMOUNT, label: "Raw amount" },
];

export const ItemDiscountDetails = memo(function ItemDiscountDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<ItemDiscountState>) {
  const description =
    state.measureOption == ItemDiscountMeasureOption.PERCENT
      ? `If the item is discounted by more than ${state.value}% from its original price`
      : `If the item is discounted by ${state.value} or greater`;
  return (
    <>
      <RedoRadioGroup
        options={MEASURE_OPTIONS}
        setValue={(measureOption) => setState({ ...state, measureOption })}
        size="xs"
        value={state.measureOption}
      />
      <RedoTextInput
        description={description}
        inputTypeHint="number"
        label="Value"
        max={
          state.measureOption === ItemDiscountMeasureOption.PERCENT
            ? 100
            : undefined
        }
        min={0}
        setValue={(e) => {
          setState({ ...state, value: +e });
        }}
        size="sm"
        value={state.value.toString()}
      />
    </>
  );
});
